angular
.module('app.views')
.controller('ScoreboardAssistRegisterFormController', function($scope, $routeParams, $modalInstance, $timeout, ScoreboardAssist, Account){
  $scope.isSaving = false;
  $scope.selectedAccount = null;

  $scope.isNew = !$routeParams.id;
  if (!$scope.isNew) {
    $scope.scoreboardAssist = ScoreboardAssist.get({id: $routeParams.id});
  }

  $scope.searchAccounts = text=> Account.query({q: text}).$promise;

  $scope.ok = function() {
    $scope.isSaving = true;

    return ScoreboardAssist.update(
      {id: $scope.scoreboardAssist.id, account_id: $scope.selectedAccount[0].id},
      a=> $modalInstance.close(a),
      error=> alert(`Error saving: ${error.error_description}`));
  };

  $timeout(() => {
    $('tags-input input').focus();
  }, 300);

  $scope.cancel = () => $modalInstance.dismiss('cancel');
});



// WEBPACK FOOTER //
// ./views/scoreboard_assist/scoreboard_assist_register_form_controller.js